import { VuexModule, Module, getModule, Mutation, Action } from 'vuex-module-decorators';
import store from '@/store/store';
import { ManagementCompanyWithReports} from '../models';
import { getMCsWithReports} from '../api';

// const TESTmcsWithReports: ManagementCompanyWithReports[] = [
//   {
//     id: 1,
//     inn: 123456789,
//     name: 'My UK Name',
//     reports: [
//       {clid: 104699, ctrlId:  323, onDate: 1583003072, cntValue: 310052, cntId:  613, cntType: 1, cntSerial: '084905'  , ctrlSerial: '1BD1E9DF530928D6', city: 'Москва', street: 'Озерковская набережная', house: '52А', building: '', flat: '9' , payCode: '52000009'},
//       {clid: 104699, ctrlId:  323, onDate: 1583103072, cntValue: 214678, cntId:  614, cntType: 2, cntSerial: '076627'  , ctrlSerial: '1BD1E9DF530928D6', city: 'Москва', street: 'Озерковская набережная', house: '52А', building: '', flat: '9' , payCode: '52000009'},
//       {clid: 104862, ctrlId: 1030, onDate: 1583203072, cntValue: 224000, cntId: 1902, cntType: 1, cntSerial: '06197358', ctrlSerial: '0773EF8EEA23B765', city: 'Москва', street: 'Озерковская наб.'      , house: '52А', building: '', flat: '8' , payCode: '52000008'},
//       {clid: 104862, ctrlId: 1030, onDate: 1583303072, cntValue:  97000, cntId: 1903, cntType: 2, cntSerial: '06190258', ctrlSerial: '0773EF8EEA23B765', city: 'Москва', street: 'Озерковская наб.'      , house: '52А', building: '', flat: '8' , payCode: '52000008'},
//       {clid: 104724, ctrlId: 1035, onDate: 1583403072, cntValue: 535095, cntId: 1911, cntType: 1, cntSerial: '06185205', ctrlSerial: 'B971FF7E53A6C13B', city: 'Москва', street: 'Озерковская набережная', house: '52А', building: '', flat: '14', payCode: '52000014'},
//       {clid: 104724, ctrlId: 1035, onDate: 1583503072, cntValue: 512010, cntId: 1912, cntType: 2, cntSerial: '06192302', ctrlSerial: 'B971FF7E53A6C13B', city: 'Москва', street: 'Озерковская набережная', house: '52А', building: '', flat: '14', payCode: '52000014'},
//     ],
//   },
// ];

@Module({
  namespaced: true,
  name: 'managementCompaniesWithReports',
  dynamic: true,
  store,
})
class MCsWithReportsModule extends VuexModule {
  private mcsWithReports: ManagementCompanyWithReports[] = [];

  @Mutation
  public clean() {
    this.mcsWithReports = [];
  }

  get firstMcWithReports() {
    // return TESTmcsWithReports.length > 0 ? TESTmcsWithReports[0] : null;
    return (this.mcsWithReports && this.mcsWithReports.length > 0) ? this.mcsWithReports[0] : null;
  }

  @Mutation
  public setMcReports(mcsReports: ManagementCompanyWithReports[]) {
    this.mcsWithReports = mcsReports;
  }

  @Action({commit: 'setMcReports'})
  public async refreshControllers(args: {uid: number, onDate?: Date}): Promise<ManagementCompanyWithReports[]> {
    return await getMCsWithReports(args.uid, args.onDate);
  }
}

export default getModule(MCsWithReportsModule);
